/**
 * ReportSubscribers entity class
 */

import moment from 'moment'
import FileSaver from 'file-saver'
import { formatDateByTimezone } from '../../../app/helpers/date'

/**
 * ReportSubscribersFactory
 * returns ReportSubscribers entity class
 *
 * @class ReportSubscribersFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ReportSubscribers} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ReportSubscribersFactory
 */
/* @ngInject */
export default function ReportSubscribersFactory ($http, Report) {
  /* === ReportSubscribers class === */

  /**
   * ReportSubscribers model
   *
   * @class ReportSubscribers
   * @classdesc ReportSubscribers model
   * @memberof models
   * @see models
   * @extends models.Report
   * @return {models.ReportSubscribers} ReportSubscribers entity
   */
  function ReportSubscribers () {
    var obj = Report.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ReportSubscribers.prototype = Object.create(Report.prototype)
  ReportSubscribers.prototype.constructor = ReportSubscribers

  /* === User instance methods & fields === */

  Object.assign(ReportSubscribers.prototype, {

    /**
     * instance fields
     *
     * @memberof models.Report#
     * @type {Object}
     */
    _fields: {
      id: Number,
      deleted: Number,
      name: String,
      status: String,
      createdTime: Number,
      from: Number,
      to: Number,
      networks: [],
      createdBy: String,
      reportType: String
    },

    /**
     * Prepare object
     *
     * @memberof models.ReportSubscribers#
     * @override
     */
    _prepare () {
      this.createdTime = formatDateByTimezone(formatDateByTimezone(this.createdTime * 1000, true).toDate(), false).toDate()
    },

    /**
     * url template
     *
     * @memberof models.ReportSubscribers#
     * @type {String}
     */
    _urlTemplate: 'api/reports/subscribers/{{::id}}',

    /**
     * Download report file.
     *
     * Overrides {@link models.Report#_download} so the Subscribers report
     * saves with the filename the backend advertises in the
     * `Content-Disposition` response header (e.g.
     * `attachment; filename=2026-05-10-2026-05-10.csv`).
     *
     * If the header is missing or unparseable, falls back to the legacy
     * `{id} {DD-MM-YYYY HH-mm}` name so the download never produces an empty
     * filename.
     *
     * @memberof models.ReportSubscribers#
     * @override
     * @param {String} type export format (e.g. 'CSV', 'ODS')
     * @param {Boolean} exprt when true, uses the `/export` endpoint instead of
     *   `/download?format=…`
     */
    _download (type, exprt = false) {
      const url = exprt
        ? this._url + '\\export'
        : this._url + '\\download?format=' + type
      $http.get(url, { responseType: 'blob' }).then((response) => {
        const match = (response.headers('content-disposition') || '')
          .match(/filename="?([^";]+)"?/i)
        const fallback = this.id + ' ' +
          moment(this.createdTime).format('DD-MM-YYYY HH-mm') +
          (!exprt && response.data.type.includes('zip') ? ' ' + type : '')
        FileSaver.saveAs(response.data, (match && match[1].trim()) || fallback)
      })
    }

  })

  /* === User static methods & fields === */

  // copy all static methods from ReportSubscribers class
  Object.assign(ReportSubscribers, Report)
  ReportSubscribers._name = 'ReportSubscribers'
  ReportSubscribers.init()

  // permissions
  // ReportSubscribers.access = {
  //   view: 'viewReport',
  //   delete: 'deleteReport'
  // }

  return ReportSubscribers
}
